"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreToJSON = exports.StoreFromJSONTyped = exports.StoreFromJSON = exports.instanceOfStore = exports.StoreFulfillViaEnum = exports.StoreHeroLogoVisibilityEnum = exports.StoreHeaderLogoTypeEnum = exports.StoreStatusEnum = void 0;
var runtime_1 = require("../runtime");
var StoreCampaignsInner_1 = require("./StoreCampaignsInner");
/**
 * @export
 */
exports.StoreStatusEnum = {
    Draft: 'draft',
    Open: 'open',
    Closed: 'closed'
};
/**
 * @export
 */
exports.StoreHeaderLogoTypeEnum = {
    Text: 'text',
    Logo: 'logo',
    CustomInkBranding: 'custom_ink_branding'
};
/**
 * @export
 */
exports.StoreHeroLogoVisibilityEnum = {
    Hidden: 'hidden',
    HeroLogo: 'hero_logo',
    HeroBackground: 'hero_background',
    HeroLogoAndBackground: 'hero_logo_and_background'
};
/**
 * @export
 */
exports.StoreFulfillViaEnum = {
    Wave: 'wave',
    Wholesale: 'wholesale'
};
/**
 * Check if a given object implements the Store interface.
 */
function instanceOfStore(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStore = instanceOfStore;
function StoreFromJSON(json) {
    return StoreFromJSONTyped(json, false);
}
exports.StoreFromJSON = StoreFromJSON;
function StoreFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'urlSlug': !(0, runtime_1.exists)(json, 'url_slug') ? undefined : json['url_slug'],
        'status': !(0, runtime_1.exists)(json, 'status') ? undefined : json['status'],
        'logoImageUrl': !(0, runtime_1.exists)(json, 'logo_image_url') ? undefined : json['logo_image_url'],
        'heroImageUrl': !(0, runtime_1.exists)(json, 'hero_image_url') ? undefined : json['hero_image_url'],
        'bannerColor': !(0, runtime_1.exists)(json, 'banner_color') ? undefined : json['banner_color'],
        'textColor': !(0, runtime_1.exists)(json, 'text_color') ? undefined : json['text_color'],
        'headerTransparent': !(0, runtime_1.exists)(json, 'header_transparent') ? undefined : json['header_transparent'],
        'headerLogoType': !(0, runtime_1.exists)(json, 'header_logo_type') ? undefined : json['header_logo_type'],
        'heroLogoVisibility': !(0, runtime_1.exists)(json, 'hero_logo_visibility') ? undefined : json['hero_logo_visibility'],
        'bannerEnabled': !(0, runtime_1.exists)(json, 'banner_enabled') ? undefined : json['banner_enabled'],
        'bannerText': !(0, runtime_1.exists)(json, 'banner_text') ? undefined : json['banner_text'],
        'storeOwnerEmail': !(0, runtime_1.exists)(json, 'store_owner_email') ? undefined : json['store_owner_email'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'companyUrl': !(0, runtime_1.exists)(json, 'company_url') ? undefined : json['company_url'],
        'eventStore': !(0, runtime_1.exists)(json, 'event_store') ? undefined : json['event_store'],
        'createdVia': !(0, runtime_1.exists)(json, 'created_via') ? undefined : json['created_via'],
        'campaigns': !(0, runtime_1.exists)(json, 'campaigns') ? undefined : (json['campaigns'].map(StoreCampaignsInner_1.StoreCampaignsInnerFromJSON)),
        'fulfillVia': !(0, runtime_1.exists)(json, 'fulfill_via') ? undefined : json['fulfill_via'],
        'capabilities': !(0, runtime_1.exists)(json, 'capabilities') ? undefined : json['capabilities'],
    };
}
exports.StoreFromJSONTyped = StoreFromJSONTyped;
function StoreToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'url_slug': value.urlSlug,
        'status': value.status,
        'logo_image_url': value.logoImageUrl,
        'hero_image_url': value.heroImageUrl,
        'banner_color': value.bannerColor,
        'text_color': value.textColor,
        'header_transparent': value.headerTransparent,
        'header_logo_type': value.headerLogoType,
        'hero_logo_visibility': value.heroLogoVisibility,
        'banner_enabled': value.bannerEnabled,
        'banner_text': value.bannerText,
        'store_owner_email': value.storeOwnerEmail,
        'description': value.description,
        'company_url': value.companyUrl,
        'event_store': value.eventStore,
        'created_via': value.createdVia,
        'campaigns': value.campaigns === undefined ? undefined : (value.campaigns.map(StoreCampaignsInner_1.StoreCampaignsInnerToJSON)),
        'fulfill_via': value.fulfillVia,
        'capabilities': value.capabilities,
    };
}
exports.StoreToJSON = StoreToJSON;
